import { Navigate, Route, Routes } from 'react-router-dom';
import { ApprovalHistoryPage } from './features/approvals/ApprovalHistoryPage';
import { LeddoCallbackScreen } from './features/auth/LeddoCallbackScreen';
import { LoginScreen } from './features/auth/LoginScreen';
import { ProtectedRoute } from './features/auth/ProtectedRoute';
import { BillingAdminScreen } from './features/billing-admin/BillingAdminScreen';
import { HomeScreen } from './features/home/HomeScreen';
import { KnowledgeBaseWebScreen } from './features/knowledge/KnowledgeBaseWebScreen';
import { MeetingDetailView } from './features/meeting/MeetingDetailView';
import { MeetingLiveReadOnly } from './features/meetings/MeetingLiveReadOnly';
import { RankingScreen } from './features/ranking/RankingScreen';
import { SearchScreen } from './features/search/SearchScreen';
import { SummariesListPage } from './features/summaries/SummariesListPage';
import { DashboardShell } from './shared/layout/DashboardShell';

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/auth/login" element={<LoginScreen />} />
      {/* Rota pública: usuário chega aqui vindo do redirect OAuth do Leddo, ainda não autenticado */}
      <Route path="/auth/leddo/callback" element={<LeddoCallbackScreen />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <DashboardShell>
              <HomeScreen />
            </DashboardShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/ranking"
        element={
          <ProtectedRoute allowedRoles={['manager', 'admin']}>
            <DashboardShell>
              <RankingScreen />
            </DashboardShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/search"
        element={
          <ProtectedRoute>
            <DashboardShell>
              <SearchScreen />
            </DashboardShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/meetings/:sessionId/live"
        element={
          <ProtectedRoute allowedRoles={['manager', 'admin']}>
            <DashboardShell>
              <MeetingLiveReadOnly />
            </DashboardShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/meetings/:meetingId"
        element={
          <ProtectedRoute>
            <DashboardShell>
              <MeetingDetailView />
            </DashboardShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/knowledge"
        element={
          <ProtectedRoute>
            <DashboardShell>
              <KnowledgeBaseWebScreen />
            </DashboardShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/approvals"
        element={
          <ProtectedRoute>
            <DashboardShell>
              <ApprovalHistoryPage />
            </DashboardShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/summaries"
        element={
          <ProtectedRoute>
            <DashboardShell>
              <SummariesListPage />
            </DashboardShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/billing"
        element={
          <ProtectedRoute requirePlatformAdmin>
            <DashboardShell>
              <BillingAdminScreen />
            </DashboardShell>
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
